import { useSelector } from "react-redux";

// Last resort when a key has no translation: the dashboard paints ~800ms before
// the translations request lands, and a raw key ("host_center") on screen looks
// broken. Render the humanized key — "Host center" — instead.
const humanize = (key) => {
  const leaf = String(key).split(".").pop() || String(key);
  const words = leaf.replace(/[_-]+/g, " ").trim();
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : key;
};

const useTranslation = () => {
  const translations = useSelector((state) => state.language.translations);
  const languageCode = useSelector((state) => state.language.selectedLanguageCode);

  const t = (key, params = {}) => {
    if (!key) return "";
    let text = translations[key];
    if (text === undefined) {
      const prefixed = `_${key}`;
      text = translations[prefixed];
    }
    if (text === undefined) {
      return humanize(key);
    }

    if (params && typeof params === "object") {
      Object.entries(params).forEach(([param, value]) => {
        const token = `{${param}}`;
        text = String(text).replaceAll(token, String(value));
      });
    }

    return text;
  };

  return { t, languageCode };
};

export default useTranslation;
